<div class="sh-loader">
	<div></div>
	<div></div>
	<div></div>
</div>
